import React, { useState } from "react";
import {
  Modal,
  Button,
  Tab,
  Nav,
  InputGroup,
  FormControl,
  Table,
} from "react-bootstrap";

const ChooseVoiceEditModal = ({ show, handleClose, handleSave }) => {
  const [selectedVoice, setSelectedVoice] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [activeTab, setActiveTab] = useState("elevenlabs");

  const voices = [
    {
      id: "1",
      name: "Adrian",
      provider: "11labs-Adrian",
      traits: ["American", "Young", "Provider"],
      image: "/assets/avatar1.png",
    },
    {
      id: "2",
      name: "Anna",
      provider: "11labs-Anna",
      traits: ["British", "Middle aged", "Provider"],
      image: "/assets/avatar2.png",
    },
    {
      id: "3",
      name: "Anthony",
      provider: "11labs-Anthony",
      traits: ["German", "Old", "Provider"],
      image: "/assets/avatar3.png",
    },
    {
      id: "4",
      name: "Ava",
      provider: "11labs-Ava",
      traits: ["French", "Senior", "Provider"],
      image: "/assets/client1.jpg",
    },
    {
      id: "5",
      name: "Aiden",
      provider: "11labs-Alex",
      traits: ["Italian", "Young", "Provider"],
      image: "/assets/client2.png",
    },
    {
      id: "6",
      name: "Amelia",
      provider: "11labs-Aidan",
      traits: ["Spanish", "Middle aged", "Provider"],
      image: "/assets/client3.jpg",
    },
  ];

  const handleVoiceSelect = (voiceId) => {
    setSelectedVoice(voiceId);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredVoices = voices.filter((voice) =>
    voice.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title className="fs-three">Select Voice</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Tab.Container activeKey={activeTab} onSelect={setActiveTab}>
          <div style={{ position: "relative" }}>
            <Nav
              variant="tabs"
              className="mb-3 custom-voice-tab-nav"
              style={{
                borderBottom: "none",
                gap: "24px",
                position: "relative",
                zIndex: 1,
              }}
            >
              <Nav.Item style={{ paddingBottom: 0 }}>
                <Nav.Link
                  eventKey="elevenlabs"
                  className={`fw-bold custom-voice-tab-link${
                    activeTab === "elevenlabs" ? " active" : ""
                  }`}
                >
                  Elevenlabs
                </Nav.Link>
              </Nav.Item>
              <Nav.Item style={{ paddingBottom: 0 }}>
                <Nav.Link
                  eventKey="playth"
                  className={`fw-bold custom-voice-tab-link${
                    activeTab === "playth" ? " active" : ""
                  }`}
                >
                  PlayTH
                </Nav.Link>
              </Nav.Item>
              <Nav.Item style={{ paddingBottom: 0 }}>
                <Nav.Link
                  eventKey="openai"
                  className={`fw-bold custom-voice-tab-link${
                    activeTab === "openai" ? " active" : ""
                  }`}
                >
                  OpenAI
                </Nav.Link>
              </Nav.Item>
            </Nav>
            {/* Custom underline */}
            <div
              style={{
                position: "absolute",
                left:
                  activeTab === "elevenlabs"
                    ? 0
                    : activeTab === "playth"
                    ? "110px"
                    : "200px",
                bottom: 0,
                width:
                  activeTab === "elevenlabs"
                    ? "90px"
                    : activeTab === "playth"
                    ? "65px"
                    : "70px",
                height: "3px",
                background: "#6C47FF",
                borderRadius: "2px",
                transition: "left 0.2s,width 0.2s",
                zIndex: 2,
              }}
            />
          </div>
          <Tab.Content>
            <Tab.Pane eventKey="elevenlabs">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                  <Button
                    variant="outline-primary"
                    className="border-purple-color fw-bold btn btn-primary me-2"
                  >
                    + Add Custom Voice
                  </Button>
                  <Button
                    variant="outline-primary"
                    className="border-purple-color fw-bold btn btn-primary"
                  >
                    Voice Library
                  </Button>
                </div>
                <div className="d-flex align-items-center">
                  <InputGroup className="border border-1 rounded search-input-group me-3">
                    <InputGroup.Text className="search-icon bg-white">
                      <img src="/assets/search.svg" alt="Search" />
                    </InputGroup.Text>
                    <FormControl
                      placeholder="Search"
                      value={searchTerm}
                      onChange={handleSearchChange}
                      className="search-input border-start-0 ps-0"
                    />
                  </InputGroup>
                  {/* Filter Icon */}
                  <Button
                    variant="outline-secondary"
                    className="d-flex align-items-center border-secondary-subtle"
                  >
                    <span className="me-1">
                      <img src="/assets/Filters_lines.svg" alt="Filters" />
                    </span>
                    Filters
                  </Button>
                </div>
              </div>
              <Table hover>
                <thead>
                  <tr>
                    <th>Voice</th>
                    <th>Voice ID</th>
                    <th>Trait</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredVoices.map((voice) => (
                    <tr
                      key={voice.id}
                      className={
                        selectedVoice === voice.id ? "table-active" : ""
                      }
                      onClick={() => handleVoiceSelect(voice.id)}
                      style={{ cursor: "pointer" }}
                    >
                      <td>
                        <img
                          src={voice.image}
                          alt={voice.name}
                          className="me-2"
                          style={{
                            width: "30px",
                            height: "30px",
                            borderRadius: "50%",
                          }}
                        />
                        {voice.name}
                      </td>
                      <td>{voice.provider}</td>
                      <td>
                        {voice.traits.map((trait, index) => (
                          <span
                            key={index}
                            className="badge bg-light text-dark me-1"
                          >
                            {trait}
                          </span>
                        ))}
                      </td>
                      <td>
                        <img
                          src="/assets/play_audio.svg"
                          alt="Play Audio"
                          style={{
                            width: "24px",
                            height: "24px",
                            cursor: "pointer",
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Tab.Pane>
            <Tab.Pane eventKey="playth">
              <p>PlayTH content goes here...</p>
            </Tab.Pane>
            <Tab.Pane eventKey="openai">
              <p>OpenAI content goes here...</p>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </Modal.Body>
      <Modal.Footer>
        <small className="text-muted">Changes will go live immediately</small>
        <Button variant="light" className="fw-bold" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant="none"
          className="ms-2 bg-purple-color fw-bold text-white"
          onClick={() => handleSave(selectedVoice)}
          disabled={!selectedVoice}
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ChooseVoiceEditModal;
